export default [
  {
    title: "Lucky Winner",
    customIcon: "DataMangeSvg",
    children: [
      {
        title: "Campaign List",
        route: "lucky-winner-campaign-list",
        path: "/lucky-winner/campaign/list",
      },
    ],
  },
]
